import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ImportDevis from './pages/ImportDevis';

const isImport = window.location.hash === '#import';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    {isImport ? <ImportDevis /> : <App />}
  </React.StrictMode>
); 